import React from 'react'

const Component = React.lazy(() => import('pages/Component/Component'));
const ComponentAdd = React.lazy(() => import('pages/Component/ComponentAdd'));
const ComponentEdit = React.lazy(() => import('pages/Component/ComponentEdit'));
const ComponentDetail = React.lazy(() => import('pages/Component/ComponentDetail'));
const ComponentCopy = React.lazy(() => import('pages/Component/ComponentCopy'));
const ComponentBarcode = React.lazy(() => import('pages/Component/ComponentBarcode'));

const ComponentRoutes = [
    {
        path: '/components',
        exact: true,
        name: 'Danh sách linh kiện',
        function: 'MD_COMPONENT_VIEW',
        component: Component,
    },
    {
        path: '/components/add',
        exact: true,
        name: 'Thêm mới',
        function: 'MD_COMPONENT_ADD',
        component: ComponentAdd,
    },
    {
        path: '/components/detail/:id',
        exact: true,
        name: 'Chi tiết',
        function: 'MD_COMPONENT_VIEW',
        component: ComponentDetail,
    },
    {
        path: '/components/edit/:id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'MD_COMPONENT_EDIT',
        component: ComponentEdit,
    },
    {
        path: '/components/copy/:id',
        exact: true,
        name: 'Sao chép',
        function: 'MD_COMPONENT_ADD',
        component: ComponentCopy,
    },
    {
        path: '/components/barcode',
        exact: true,
        name: 'In mã vạch',
        function: 'MD_COMPONENT_ADD',
        component: ComponentBarcode,
    },  
    {
        path: '/components/barcode-list',
        exact: true,
        name: 'In barcode bất kỳ',
        function: 'MD_COMPONENT_ADD',
        component: ComponentBarcode,
    },
]

export default ComponentRoutes
